/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from 'types/enums';

export const TimeLogFilter = yup.object({
   filterType: yup.string().oneOf(enums.filterType.keys).default(enums.filterType.enum.TIME_FILTER),
   earliestTime: yup.dateString(), //date(),
   latestTime: yup.dateString(), //date(),
});
export type ITimeLogFilter = yup.InferType<typeof TimeLogFilter>;
